import { render, staticRenderFns } from "./PersonalCoverRiskFactors.vue?vue&type=template&id=52996552&scoped=true"
import script from "./PersonalCoverRiskFactors.vue?vue&type=script&lang=js"
export * from "./PersonalCoverRiskFactors.vue?vue&type=script&lang=js"
import style0 from "./PersonalCoverRiskFactors.vue?vue&type=style&index=0&id=52996552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52996552",
  null
  
)

export default component.exports